// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: Arial, sans-serif;
    overflow-x: hidden;
}

.header-nav {
    background-color: white;
    color: grey;
    padding: 8px 12px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    box-sizing: border-box;
}

/* Navbar Layout */
.navbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 1400px;
    margin: 0 auto;
    padding: 4px 16px;
    width: 100%;
    box-sizing: border-box;
}

.logo-container .logo {
    font-size: 1.5rem;
    font-weight: bold;
    color: rgb(0, 119, 255);
    text-decoration: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.logo-search {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
}

/* Desktop Navigation Links */
.nav-links {
    display: flex;
    flex-direction: row;
    list-style: none;
    gap: 15px;
    margin: 0;
    padding: 0;
    align-items: center;
    flex-wrap: nowrap;
}

.nav-item {
    text-decoration: none;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    padding: 5px 0;
    position: relative;
    min-width: 50px;
    flex-shrink: 0;
}

.nav-item img {
    width: 24px;
    height: 24px;
    margin-bottom: 2px;
}

.nav-item span {
    font-size: 12px;
    white-space: nowrap;
}

.nav-item.active {
    color: #0073b1;
}

/* Badges */
.nav-badge {
    position: absolute;
    top: -5px;
    right: -8px;
    background: #ff4500;
    color: white;
    font-size: 0.5rem;
    min-width: 12px;
    height: 13px;
    padding: 0 1px;
    border-radius: 100%;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Mobile Menu Button */
.mobile-menu-btn {
    display: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #333;
    margin-left: auto;
    padding-left: 20px;
}

/* Mobile Dropdown Navigation */
.mobile-dropdown-nav {
    width: 100%;
    background: white;
    border-top: 1px solid #eee;
}

.dropdown-content {
    display: flex;
    flex-direction: column;
    background-color: white;
}

.dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    text-decoration: none;
    color: #333;
    border-bottom: 1px solid #eee;
}

.dropdown-item img {
    width: 24px;
    height: 24px;
    margin-right: 15px;
}

.dropdown-item.active {
    color: #0073b1;
    background-color: #f0f4f9;
}

.mobile-badge {
    margin-left: auto;
    background: #ff4500;
    color: white;
    font-size: 0.7rem;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .nav-links { gap: 12px; }
    .navbar { padding: 4px 8px; }
}

@media (max-width: 992px) {
    .nav-item span { font-size: 11px; }
    .nav-links { gap: 10px; }
}

@media (max-width: 768px) {
    .header-nav {
        padding: 6px 8px;
    }

    /* Hide desktop nav on mobile */
    .nav-links {
        display: none;
    }

    /* Show hamburger on mobile */
    .mobile-menu-btn {
        display: block;
    }

    .logo-search {
        width: 100%;
        justify-content: space-between;
    }

    .navbar {
        padding: 2px 8px;
    }
}

@media (max-width: 576px) {
    .header-nav { padding: 4px 4px; }
    .logo-container .logo { font-size: 1.1rem; }
    .dropdown-item { padding: 10px 8px; }
}

@media (max-width: 400px) {
    .logo-container .logo { font-size: 1rem; }
    .header-nav { padding: 3px 2px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,0CAA0C;IAC1C,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,sBAAsB;AACtB;IACI,aAAa,SAAS,EAAE;IACxB,UAAU,gBAAgB,EAAE;AAChC;;AAEA;IACI,iBAAiB,eAAe,EAAE;IAClC,aAAa,SAAS,EAAE;AAC5B;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA,+BAA+B;IAC/B;QACI,aAAa;IACjB;;IAEA,6BAA6B;IAC7B;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc,gBAAgB,EAAE;IAChC,wBAAwB,iBAAiB,EAAE;IAC3C,iBAAiB,iBAAiB,EAAE;AACxC;;AAEA;IACI,wBAAwB,eAAe,EAAE;IACzC,cAAc,gBAAgB,EAAE;AACpC","sourcesContent":["body {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    overflow-x: hidden;\n}\n\n.header-nav {\n    background-color: white;\n    color: grey;\n    padding: 8px 12px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 1000;\n    box-sizing: border-box;\n}\n\n/* Navbar Layout */\n.navbar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 4px 16px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.logo-container .logo {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: rgb(0, 119, 255);\n    text-decoration: none;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n}\n\n.logo-search {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 20px;\n    flex-shrink: 0;\n}\n\n/* Desktop Navigation Links */\n.nav-links {\n    display: flex;\n    flex-direction: row;\n    list-style: none;\n    gap: 15px;\n    margin: 0;\n    padding: 0;\n    align-items: center;\n    flex-wrap: nowrap;\n}\n\n.nav-item {\n    text-decoration: none;\n    color: #333;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 14px;\n    padding: 5px 0;\n    position: relative;\n    min-width: 50px;\n    flex-shrink: 0;\n}\n\n.nav-item img {\n    width: 24px;\n    height: 24px;\n    margin-bottom: 2px;\n}\n\n.nav-item span {\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n.nav-item.active {\n    color: #0073b1;\n}\n\n/* Badges */\n.nav-badge {\n    position: absolute;\n    top: -5px;\n    right: -8px;\n    background: #ff4500;\n    color: white;\n    font-size: 0.5rem;\n    min-width: 12px;\n    height: 13px;\n    padding: 0 1px;\n    border-radius: 100%;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Mobile Menu Button */\n.mobile-menu-btn {\n    display: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #333;\n    margin-left: auto;\n    padding-left: 20px;\n}\n\n/* Mobile Dropdown Navigation */\n.mobile-dropdown-nav {\n    width: 100%;\n    background: white;\n    border-top: 1px solid #eee;\n}\n\n.dropdown-content {\n    display: flex;\n    flex-direction: column;\n    background-color: white;\n}\n\n.dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 15px;\n    text-decoration: none;\n    color: #333;\n    border-bottom: 1px solid #eee;\n}\n\n.dropdown-item img {\n    width: 24px;\n    height: 24px;\n    margin-right: 15px;\n}\n\n.dropdown-item.active {\n    color: #0073b1;\n    background-color: #f0f4f9;\n}\n\n.mobile-badge {\n    margin-left: auto;\n    background: #ff4500;\n    color: white;\n    font-size: 0.7rem;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 5px;\n    border-radius: 10px;\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .nav-links { gap: 12px; }\n    .navbar { padding: 4px 8px; }\n}\n\n@media (max-width: 992px) {\n    .nav-item span { font-size: 11px; }\n    .nav-links { gap: 10px; }\n}\n\n@media (max-width: 768px) {\n    .header-nav {\n        padding: 6px 8px;\n    }\n\n    /* Hide desktop nav on mobile */\n    .nav-links {\n        display: none;\n    }\n\n    /* Show hamburger on mobile */\n    .mobile-menu-btn {\n        display: block;\n    }\n\n    .logo-search {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .navbar {\n        padding: 2px 8px;\n    }\n}\n\n@media (max-width: 576px) {\n    .header-nav { padding: 4px 4px; }\n    .logo-container .logo { font-size: 1.1rem; }\n    .dropdown-item { padding: 10px 8px; }\n}\n\n@media (max-width: 400px) {\n    .logo-container .logo { font-size: 1rem; }\n    .header-nav { padding: 3px 2px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
